// 0件表示行（発注照合テーブルの実装を切り出した共通部品）。
// 空欄と未描画の区別が付くよう、0件のときは明示的にメッセージ行を出す（docs/develop/client_ui/screens/states.md「空状態は2種類を必ず分ける」）。
// セルは colSpan で列数ぶん（横スクロール込みの実テーブル幅）まで伸びるため、td に text-center を付けると
// 可視範囲外（右側）に文字が流れてしまう。スクロール領域（data-table-shell の container-type: inline-size）の
// 可視幅 100cqw を持つ要素を sticky で左端に固定し、その中で中央揃えにする
export function DataTableEmptyRow({ colSpan, message }: { colSpan: number; message: string }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-10 text-sm text-muted-foreground">
        <div className="sticky left-0 w-[calc(100cqw-2rem)] text-center">{message}</div>
      </td>
    </tr>
  )
}
